// extracted by mini-css-extract-plugin
module.exports = {"basic_add_form_style":"BasicAddForm_basic_add_form_style__mM_8z","form_content_with_error":"BasicAddForm_form_content_with_error__e6gDv"};